import { useState } from 'react';
import { useRequest } from 'umi';
import { getTermsAndConditions } from '@/services/term';

export default function useTermModel() {
  const [terms, setTerms] = useState<API.Terms>({} as API.Terms);

  const { loading, run } = useRequest(getTermsAndConditions, {
    cacheKey: 'term',
    manual: true,
    formatResult: (res) => res,
    onSuccess: (data) => setTerms(data),
  });

  return { terms, fetchTerm: run, loading };
}
